/**
 * Norwegian date/time formatting.
 *
 * Long form per mockup: "24. mai 2026"
 * Short form for table cells: "24.05.2026"
 * Time is 24-hour.
 */

const longFormatter = new Intl.DateTimeFormat("nb-NO", {
  day: "numeric",
  month: "long",
  year: "numeric",
});

const shortFormatter = new Intl.DateTimeFormat("nb-NO", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

const timeFormatter = new Intl.DateTimeFormat("nb-NO", {
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

const toDate = (input: Date | string | number): Date =>
  input instanceof Date ? input : new Date(input);

/** "24. mai 2026" */
export const formatDateLong = (input: Date | string | number): string =>
  longFormatter.format(toDate(input));

/** "24.05.2026" */
export const formatDateShort = (input: Date | string | number): string =>
  shortFormatter.format(toDate(input));

/** "14:30" */
export const formatTime = (input: Date | string | number): string =>
  timeFormatter.format(toDate(input));
